import type { ComponentType, SVGProps } from 'react';

import {
  InstagramSocialIcon,
  MaxSocialIcon,
  TelegramSocialIcon,
  VkSocialIcon,
} from '@/components/icons/social-network';
import {
  getSocialLinkLabel,
  SOCIAL_NETWORKS,
  type ProfileSocialLinks,
  type SocialNetwork,
} from '@/features/profile/utils/social-link.util';

const SOCIAL_ICONS: Record<SocialNetwork, ComponentType<SVGProps<SVGSVGElement>>> = {
  instagram: InstagramSocialIcon,
  vk: VkSocialIcon,
  telegram: TelegramSocialIcon,
  max: MaxSocialIcon,
};

type AuthorSocialBadgesProps = {
  links: ProfileSocialLinks;
};

export function AuthorSocialBadges({ links }: AuthorSocialBadgesProps) {
  const visibleLinks = SOCIAL_NETWORKS.flatMap((network) => {
    const href = links[network];
    return href ? [{ network, href }] : [];
  });

  if (visibleLinks.length === 0) {
    return null;
  }

  return (
    <div className="flex shrink-0 items-center gap-1.5 sm:gap-2">
      {visibleLinks.map(({ network, href }) => {
        const Icon = SOCIAL_ICONS[network];
        return (
          <a
            key={network}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={getSocialLinkLabel(network)}
            className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-[#F2F3F7] text-[#6C7076] sm:h-9 sm:w-9 dark:bg-[#3a3f47] dark:text-[#C5C8CE]"
          >
            <Icon
              className={
                network === 'vk'
                  ? 'h-5 w-5 sm:h-[22px] sm:w-[22px]'
                  : 'h-4 w-4 sm:h-[18px] sm:w-[18px]'
              }
            />
          </a>
        );
      })}
    </div>
  );
}
